import getPortalFacetFilter from '@/utils/PortalFacetFilter';
import { IProgrammeCard } from '@studyportals/domain-client';
import { BaseSuperAgentRequestFactory, RequestSender } from '@studyportals/mb-platform-http-requests/base';
import { IProgrammeResult, IProgrammeSearchResponse, ProgrammeSearchFilters, ProgrammeSearchInput, SearchApiProgrammeClient, TextSearchAlgorithmType } from '@studyportals/search-api-interface';

declare const SEARCH_API_URL: string;


export default class ResultsRepository {
	private readonly searchApiProgrammeClient: SearchApiProgrammeClient;
	private readonly baseSuperAgentRequestFactory: BaseSuperAgentRequestFactory;
	private readonly requestSender: RequestSender;
	constructor() {
		this.baseSuperAgentRequestFactory = new BaseSuperAgentRequestFactory();
		this.requestSender = new RequestSender();
		this.searchApiProgrammeClient = new SearchApiProgrammeClient(SEARCH_API_URL, this.baseSuperAgentRequestFactory, this.requestSender);
	}

	public async getResult(input: ProgrammeSearchInput): Promise<IProgrammeSearchResponse<IProgrammeResult<IProgrammeCard>>|null>{
		const portalFilter: ProgrammeSearchInput = getPortalFacetFilter();

		const result = await this.searchApiProgrammeClient.searchCards(new ProgrammeSearchFilters().from({
			...input,
			...portalFilter,
			textSearchAlgorithm: TextSearchAlgorithmType.SIMILARITY_SEARCH
		}), 5, 0);

		if (result) {
			return result;
		}

		return null;
	}
}